// Avatar component - Display user profile photo or initials
import React from 'react';

const Avatar = React.memo(({ player, size = 'md', onClick }) => {
  const sizeClasses = {
    sm: 'w-8 h-8 text-sm',
    md: 'w-10 h-10 text-base',
    lg: 'w-12 h-12 text-lg',
    xl: 'w-16 h-16 text-2xl',
    '2xl': 'w-24 h-24 text-4xl'
  };

  const sizeClass = sizeClasses[size] || sizeClasses.md;

  return (
    <div
      className={`${sizeClass} rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center overflow-hidden flex-shrink-0 ${
        onClick ? 'cursor-pointer hover:ring-2 hover:ring-blue-500' : ''
      }`}
      onClick={onClick}
      title={player?.displayName}
    >
      {player?.photoURL ? (
        <img
          src={player.photoURL}
          alt={player.displayName}
          className="w-full h-full object-cover"
        />
      ) : (
        <span className="font-bold text-white">
          {player?.displayName?.charAt(0).toUpperCase() || '?'}
        </span>
      )}
    </div>
  );
});

Avatar.displayName = 'Avatar';

export default Avatar;
